import React, { useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import './SostenibilidadRolesContainer.css'
import { TextField, Button } from '@material-ui/core'
import { getPermissions } from '@auteco/utils/Common'

import {
  getRoles,
  getPermisosByRol,
  addPermiso,
  addRol,
} from '@auteco/services/sostenibilidadService'

const SostenibilidadRolesContainer = () => {
  const [roles, setRoles] = useState([])
  const [permisos, setPermisos] = useState([])
  const [editingRole, setEditingRole] = useState(null)
  const [nombreRol, setNombreRol] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const permissions = getPermissions()

  const columns = [
    { title: 'Rol', field: 'nombre' },
    { title: 'Activo', field: 'activo', type: 'boolean' },
  ]

  const handlePermissionChange = async (permisoId, alcance) => {
    setIsLoading(true)
    console.log(permisoId, alcance)
    const response = await addPermiso({
      rol_id: editingRole.id,
      permiso_id: permisoId,
      alcance,
    })
    setIsLoading(false)

    if (response) {
      handleEditRole(editingRole)
    }
  }

  const PermissionsForm = () => (
    <div  className={`permissions-form ${isLoading ? 'my-loading' : ''}`}>
      <h3>Permisos para {editingRole?.nombre}</h3>
      {permisos.map((permiso) => (
        <div key={permiso.id} className="category">
          <strong>{permiso.permiso_nombre}</strong>
          <div className="actions">
            <label key={1} className="action">
              <input
                type="checkbox"
                checked={permiso.alcance >= 1}
                onChange={() => {
                  if (permiso.alcance === '0') {
                    handlePermissionChange(permiso.permiso_id, 1)
                  } else {
                    handlePermissionChange(permiso.permiso_id, 0)
                  }
                }}
              />
              Visualizar
            </label>
            <label key={2} className="action">
              <input
                type="checkbox"
                checked={permiso.alcance >= 2}
                onChange={() => handlePermissionChange(permiso.permiso_id, 2)}
              />
              Crear
            </label>
            <label key={3} className="action">
              <input
                type="checkbox"
                checked={permiso.alcance >= 3}
                onChange={() => handlePermissionChange(permiso.permiso_id, 3)}
              />
              Actualizar
            </label>
            <label key={4} className="action">
              <input
                type="checkbox"
                checked={permiso.alcance >= 4}
                onChange={() => handlePermissionChange(permiso.permiso_id, 4)}
              />
              Eliminar
            </label>
          </div>
        </div>
      ))}
      {/* <button className="save-button" onClick={handleSavePermissions}>
        Editar / Guardar roles
      </button> */}
    </div>
  )

  const handleGetRoles = async () => {
    const response = await getRoles()
    if (response) {
      setRoles(response.roles)
    }
  }

  const handleEditRole = async (role) => {
    await setEditingRole(role)
    const response2 = await getPermisosByRol(role.id)
    if (response2.rol_permisos) {
      setPermisos(response2.rol_permisos)
    }
  }

  useEffect(() => {
    handleGetRoles()
  }, [])

  const handleAddRoll = async () => {
    const response = await addRol({ nombre: nombreRol })
    if (response) {
      handleGetRoles()
      setNombreRol('')
    }
  }

  if (permissions[73] !== 5) {
    return (
      <div>
        <p>Permisos insuficientes</p>
      </div>
    )
  }
  return (
    <div>
      <MaterialTable
        title="Listado de Roles"
        columns={columns}
        data={roles}
        options={{
          headerStyle: {
            backgroundColor: '#35465c',
            color: 'white',
            fontSize: '14px',
            fontWeight: 700,
          },
        }}
        actions={[
          {
            icon: 'edit',
            tooltip: 'Editar Rol',
            onClick: (event, rowData) => handleEditRole({ ...rowData }),
          },
        ]}
      />

      {editingRole && <PermissionsForm />}

      <div className="container_baterias_form">
        <h3>Nuevo Rol</h3>
        <div className="form_baterias">
          {' '}
          <TextField
            label="Nombre"
            type="text"
            value={nombreRol}
            onChange={(e) => setNombreRol(e.target.value)}
            fullWidth
          />
          <Button
            variant="contained"
            color="primary"
            disabled={!nombreRol || nombreRol.length < 3}
            style={{ marginTop: '10px' }}
            onClick={() => handleAddRoll()}
          >
            Agregar
          </Button>
        </div>
      </div>
    </div>
  )
}

export default SostenibilidadRolesContainer
